import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";

const Unavailable = () => {
  return (
    <Fragment>
      <div className="not-available">
        <FormattedMessage
          id="tutorials.product_unavailable"
          defaultMessage="This product is currently unavailable in this market."
        />
      </div>
    </Fragment>
  );
};

export default Unavailable;
